module.exports = __webpack_public_path__ + "img/yatsuhashi tsukumo_sc1.5bbf1256.png";